export default __webpack_public_path__ + "static/media/report_expand_active.2ad1fbb8.svg";